<template>
	<div id="top">
		<div class="logoEmpresa">
			<router-link to="/">
				<img class="h-100 w-100" src="@/assets/logo.png" />
			</router-link>
		</div>
		<div class="logoMenu">
			<pm-menu></pm-menu>
		</div>

		<div class="fullscreen mb-4">
			<div class="container-fluid">
				<slot name="contenido"></slot>
			</div>
		</div>
	</div>
</template>

<script>
	import PmMenu from "@/components/publica/Menu"
	export default {
		components: {
			PmMenu
		}
	}
</script>

<style scoped>
	.fullscreen {
		position: relative;
		height: 120px;
		width: 100%;
		background-color: var(--color-azul);
	}

	.logoEmpresa {
		position: absolute;
		margin: 0;
		top: 2em;
		left: 2em;
		z-index: 1;
	}

	.logoMenu {
		position: absolute;
		right: 2em;
		top: 2em;
		color: var(--color-blanco);
		z-index: 1;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.fullscreen {
			height: 50px;
		}
		.logoEmpresa {
			top: 10px;
			left: 10px;
			width: 100px;
		}
		.logoMenu {
			right: 10px;
			top: 0px;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.fullscreen {
			height: 50px;
		}
		.logoEmpresa {
			top: 10px;
			left: 10px;
		}
		.logoMenu {
			right: 10px;
			top: 0px;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fullscreen {
			height: 50px;
		}
		.logoEmpresa {
			top: 10px;
			left: 10px;
		}
		.logoMenu {
			right: 10px;
			top: 0px;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
	}
</style>